import logoImage from './logo.svg';
import logoDealerImage from './logo-dealer.svg';
import logoAGIImage from './logo-agi.svg';
import logoWarrantyImage from './logo-warranty.svg';
import logoShape from './logo-shape.svg';
// import logoPartsOutline from './logo-parts.svg';

/**
 * Name with `logo` word
 */
export {
  logoImage,
  logoDealerImage,
  logoAGIImage,
  logoWarrantyImage,
  logoShape
  // logoPartsOutline,
};



// WEBPACK FOOTER //
// ./src/images/logos/index.js